import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetParentChildCasesQuery } from './get-parent-child-cases.query';
import { GetParentChildCasesResult } from './get-parent-child-cases.result';

/**
 * Get parent/child cases use case.
 * Retrieves the parent and children for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetParentChildCasesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetParentChildCasesQuery): Observable<GetParentChildCasesResult> {
    this._state.setLoadingParentChildCases(true);
    this._state.setErrorParentChildCases(null);

    return this._repository.getParentChildCases(query.caseId).pipe(
      tap((parentChildCases) => {
        this._state.setParentChildCases(parentChildCases);
        this._state.setLoadingParentChildCases(false);
      }),
      map((parentChildCases) => ({ parentChildCases })),
      catchError((error) => {
        this._state.setErrorParentChildCases(error.message || 'Failed to get parent/child cases');
        this._state.setLoadingParentChildCases(false);
        return throwError(() => error);
      })
    );
  }
}
